// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/lift-equation-and-density.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/lift-equation-and-density/lift-equation-and-density.js';

mount([g0]);
